<div class="modal-header">
  <h4 class="modal-title pull-left fw-bold">Term & Condition</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="closeModal()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body add-referral-container p-5 overflow-y-scroll" style="background: #F1F3FA;height: 75vh">
  <h1>Terms and Conditions</h1>
  <div class="content">
    <h2>Introduction</h2>
    <p>Welcome to [Your Website Name]! By accessing or using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our website or services.</p>

    <h2>Use of the Website</h2>
    <p>By using this website, you agree not to use it for any unlawful or prohibited purpose. You agree to comply with all applicable laws and regulations when accessing or using our website.</p>

    <h2>Account Registration</h2>
    <p>If you create an account on our website, you agree to provide accurate and up-to-date information. You are responsible for maintaining the confidentiality of your account details.</p>

    <h2>Intellectual Property</h2>
    <p>All content, trademarks, and intellectual property on the website are owned by [Your Website Name] or its licensors. You may not use, reproduce, or distribute any content without proper authorization.</p>

    <h2>Privacy Policy</h2>
    <p>Your use of the website is also governed by our <a href="privacy-policy.html">Privacy Policy</a>, which explains how we collect, use, and protect your personal information.</p>

    <h2>Limitations of Liability</h2>
    <p>We make no guarantees about the accuracy, reliability, or completeness of the content on our website. We are not liable for any damages or losses resulting from your use of the website or services.</p>

    <h2>Changes to Terms</h2>
    <p>We reserve the right to modify or update these terms at any time. You will be notified of any significant changes via email or on the website.</p>

    <h2>Governing Law</h2>
    <p>These terms and conditions are governed by and construed in accordance with the laws of [Your Country]. Any disputes shall be resolved in the competent courts of [Your City or Country].</p>

    <h2>Contact Information</h2>
    <p>If you have any questions regarding these terms and conditions, please contact us at [Your Contact Information].</p>
  </div>
</div>
